/* ==========================================================================
   HYPE SPOT OUTLET - INTERACTIVE STOREFRONT LOGIC
   ========================================================================== */

// Global Drawer & Search Handlers (accessible immediately from HTML onclick and JS)
window.toggleSearchOverlay = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  if (window.closeCartDrawer) window.closeCartDrawer();
  if (window.closeAuthDrawer) window.closeAuthDrawer();
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput = document.getElementById('store-search-input');
  if (searchOverlay) {
    searchOverlay.classList.toggle('open');
    if (searchOverlay.classList.contains('open') && searchInput) {
      setTimeout(() => searchInput.focus(), 60);
    }
  }
};

window.closeSearchOverlay = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput = document.getElementById('store-search-input');
  if (searchOverlay) {
    searchOverlay.classList.remove('open');
    if (searchInput) searchInput.value = '';
    if (typeof filterProducts === 'function') filterProducts('');
  }
};

window.clearHeaderSearch = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const input = document.getElementById('header-search-input');
  const clearBtn = document.getElementById('search-clear-btn');
  const dropdown = document.getElementById('predictive-search-dropdown');
  if (input) {
    input.value = '';
    input.focus();
  }
  if (clearBtn) clearBtn.style.display = 'none';
  if (dropdown) dropdown.style.display = 'none';
  if (typeof window.filterProducts === 'function') {
    window.filterProducts('');
  }
};

window.filterProducts = function(query) {
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    const title = card.dataset.title || '';
    const brand = card.dataset.brand || '';
    const cat = card.dataset.category || '';

    if (!query || title.includes(query) || brand.includes(query) || cat.includes(query)) {
      card.style.display = 'flex';
    } else {
      card.style.display = 'none';
    }
  });
};

window.openCartDrawer = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  if (window.closeAuthDrawer) window.closeAuthDrawer();
  if (window.closeSearchOverlay) window.closeSearchOverlay();
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  if (cartDrawer && cartDrawerOverlay) {
    cartDrawer.classList.add('open');
    cartDrawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (typeof refreshCartDrawer === 'function') {
      refreshCartDrawer();
    }
  }
};

window.closeCartDrawer = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  if (cartDrawer && cartDrawerOverlay) {
    cartDrawer.classList.remove('open');
    cartDrawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
};

window.openAuthDrawer = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  if (window.closeCartDrawer) window.closeCartDrawer();
  if (window.closeSearchOverlay) window.closeSearchOverlay();
  const authDrawer = document.getElementById('auth-drawer');
  const authDrawerOverlay = document.getElementById('auth-drawer-overlay');
  if (authDrawer && authDrawerOverlay) {
    authDrawer.classList.add('open');
    authDrawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    const emailInput = document.getElementById('drawer_fast_email');
    if (emailInput) setTimeout(() => emailInput.focus(), 80);
  }
};

window.closeAuthDrawer = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const authDrawer = document.getElementById('auth-drawer');
  const authDrawerOverlay = document.getElementById('auth-drawer-overlay');
  if (authDrawer && authDrawerOverlay) {
    authDrawer.classList.remove('open');
    authDrawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
};

window.openMobileMenu = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const mobileDrawer = document.getElementById('mobile-nav-drawer');
  if (mobileDrawer) mobileDrawer.classList.add('open');
};

window.closeMobileMenu = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const mobileDrawer = document.getElementById('mobile-nav-drawer');
  if (mobileDrawer) mobileDrawer.classList.remove('open');
};

// ==========================================
// Custom InPost Paczkomat Picker (Leaflet + Open Data)
// ==========================================
window.INPOST_POINTS = null;
window.inpostMap = null;
window.inpostMarkersLayer = null;
window.userLocationMarker = null;
let searchDebounceTimer = null;

// Initialize Picker Map & Fetch Points
window.initInpostPicker = function() {
  if (!window.inpostMap && typeof L !== 'undefined') {
    const mapEl = document.getElementById('inpost-leaflet-map');
    if (mapEl) {
      window.inpostMap = L.map('inpost-leaflet-map', {
        zoomControl: true,
        attributionControl: false
      }).setView([52.2297, 21.0122], 12);

      L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
        subdomains: 'abc',
        maxZoom: 19
      }).addTo(window.inpostMap);

      window.inpostMarkersLayer = L.layerGroup().addTo(window.inpostMap);
    }
  }

  // Load points dataset once
  if (!window.INPOST_POINTS) {
    const statusEl = document.getElementById('inpost-sidebar-status');
    if (statusEl) statusEl.textContent = 'Pobieranie bazy Paczkomatów w Polsce...';

    fetch('https://inpost.pl/sites/default/files/points.json')
      .then(res => res.json())
      .then(data => {
        window.INPOST_POINTS = data.items || data;
        console.log(`Załadowano ${window.INPOST_POINTS.length} Paczkomatów InPost.`);
        if (statusEl) statusEl.textContent = `Wyszukaj miasto, ulicę lub kliknij „Moja lokalizacja” (${window.INPOST_POINTS.length} Paczkomatów).`;

        renderLockerResults(window.INPOST_POINTS.slice(0, 20));
      })
      .catch(err => {
        console.error('Błąd pobierania punktów InPost:', err);
        if (statusEl) statusEl.textContent = 'Możesz wpisać kod Paczkomatu ręcznie w wyszukiwarce.';
      });
  } else {
    renderLockerResults(window.INPOST_POINTS.slice(0, 20));
  }

  setTimeout(() => {
    if (window.inpostMap) window.inpostMap.invalidateSize();
  }, 250);
};

// Create custom InPost Pin Marker
function createInpostMarker(p, distStr) {
  const icon = L.divIcon({
    className: 'inpost-marker-custom',
    html: `<div class="inpost-pin" title="${p.n}"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#000" stroke-width="2.2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg></div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -30]
  });

  const marker = L.marker([p.l.a, p.l.o], { icon: icon });
  const addrStr = (p.e ? `ul. ${p.e} ${p.b}` : p.b) + (p.c ? `, ${p.c}` : '');

  const popupHtml = `
    <div class="inpost-popup-inner">
      <span class="inpost-popup-code">${p.n}</span>
      <div class="inpost-popup-addr">${addrStr}</div>
      ${p.d ? `<div class="inpost-popup-desc">${p.d}</div>` : ''}
      ${distStr ? `<div style="font-size: 0.75rem; color: #ffcc00; font-weight: 700;">Odległość: ${distStr}</div>` : ''}
      <button type="button" class="btn-popup-select" onclick="selectInpostPoint('${p.n}')">
        Wybierz ten Paczkomat
      </button>
    </div>
  `;

  marker.bindPopup(popupHtml);
  return marker;
}

// Render Results on Map & Sidebar
function renderLockerResults(lockers, userLat, userLng) {
  const listEl = document.getElementById('inpost-results-list');
  if (!listEl) return;
  listEl.innerHTML = '';

  if (window.inpostMarkersLayer) {
    window.inpostMarkersLayer.clearLayers();
  }

  if (!lockers || lockers.length === 0) {
    listEl.innerHTML = '<div style="padding: 1.5rem; text-align: center; color: var(--text-muted); font-size: 0.85rem;">Nie znaleziono Paczkomatów dla podanego zapytania. Sprawdź pisownię lub wpisz kod ręcznie.</div>';
    return;
  }

  const bounds = [];

  lockers.forEach((p) => {
    let distStr = '';
    if (userLat && userLng) {
      const dKm = calculateHaversineDistance(userLat, userLng, p.l.a, p.l.o);
      distStr = dKm < 1 ? Math.round(dKm * 1000) + ' m' : dKm.toFixed(1) + ' km';
    }

    const addrStr = (p.e ? `ul. ${p.e} ${p.b}` : p.b) + (p.c ? `, ${p.c}` : '');

    const card = document.createElement('div');
    card.className = 'inpost-card';
    card.id = `inpost-card-${p.n}`;
    card.innerHTML = `
      <div class="inpost-card-top">
        <span class="inpost-card-code">${p.n}</span>
        ${distStr ? `<span class="inpost-card-dist">${distStr}</span>` : ''}
      </div>
      <div class="inpost-card-addr">${addrStr}</div>
      ${p.d ? `<div class="inpost-card-desc">${p.d}</div>` : ''}
      <button type="button" class="btn-card-select" onclick="event.stopPropagation(); selectInpostPoint('${p.n}')">
        Wybierz
      </button>
    `;

    const marker = createInpostMarker(p, distStr);
    if (window.inpostMarkersLayer) {
      window.inpostMarkersLayer.addLayer(marker);
    }
    bounds.push([p.l.a, p.l.o]);

    card.addEventListener('click', () => {
      if (window.inpostMap) {
        window.inpostMap.setView([p.l.a, p.l.o], 16, { animate: true });
        marker.openPopup();
      }
      document.querySelectorAll('.inpost-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
    });

    listEl.appendChild(card);
  });

  if (window.inpostMap && bounds.length > 0 && !userLat) {
    try {
      window.inpostMap.fitBounds(bounds, { padding: [30, 30], maxZoom: 15 });
    } catch (e) {}
  }
}

// Haversine Distance in km
function calculateHaversineDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Search Input Debounce
window.handleInpostSearchInput = function(val) {
  const clearBtn = document.getElementById('inpost-clear-btn');
  if (clearBtn) clearBtn.style.display = val ? 'block' : 'none';

  clearTimeout(searchDebounceTimer);
  searchDebounceTimer = setTimeout(() => {
    window.executeInpostSearch(val);
  }, 220);
};

window.clearInpostSearch = function() {
  const inp = document.getElementById('inpost-search-query');
  if (inp) inp.value = '';
  const clearBtn = document.getElementById('inpost-clear-btn');
  if (clearBtn) clearBtn.style.display = 'none';
  if (window.INPOST_POINTS) {
    renderLockerResults(window.INPOST_POINTS.slice(0, 20));
  }
};

// Search Logic
window.executeInpostSearch = function(customVal) {
  const inp = document.getElementById('inpost-search-query');
  const q = (typeof customVal === 'string' ? customVal : (inp ? inp.value : '')).trim().toLowerCase();

  if (!window.INPOST_POINTS || window.INPOST_POINTS.length === 0) return;

  if (!q) {
    renderLockerResults(window.INPOST_POINTS.slice(0, 20));
    return;
  }

  const matches = [];
  for (let i = 0; i < window.INPOST_POINTS.length; i++) {
    const p = window.INPOST_POINTS[i];
    const n = (p.n || '').toLowerCase();
    const c = (p.c || '').toLowerCase();
    const e = (p.e || '').toLowerCase();
    const o = (p.o || '').toLowerCase();
    const d = (p.d || '').toLowerCase();

    if (n.includes(q) || c.includes(q) || e.includes(q) || o.includes(q) || d.includes(q)) {
      matches.push(p);
      if (matches.length >= 35) break;
    }
  }

  const statusEl = document.getElementById('inpost-sidebar-status');
  if (statusEl) statusEl.textContent = `Wyniki dla: „${q}” (znaleziono: ${matches.length})`;

  renderLockerResults(matches);
};

// GPS Geolocation
window.locateUserInpost = function() {
  if (!navigator.geolocation) {
    alert('Twoja przeglądarka nie obsługuje lokalizacji.');
    return;
  }

  const statusEl = document.getElementById('inpost-sidebar-status');
  if (statusEl) statusEl.textContent = 'Pobieranie pozycji GPS...';

  navigator.geolocation.getCurrentPosition(
    pos => {
      const uLat = pos.coords.latitude;
      const uLng = pos.coords.longitude;

      if (!window.INPOST_POINTS || window.INPOST_POINTS.length === 0) return;

      const withDist = window.INPOST_POINTS.map(p => ({
        ...p,
        _dist: calculateHaversineDistance(uLat, uLng, p.l.a, p.l.o)
      }));

      withDist.sort((a, b) => a._dist - b._dist);
      const closest = withDist.slice(0, 25);

      if (statusEl) statusEl.textContent = 'Najbliższe Paczkomaty w Twojej okolicy:';

      if (window.inpostMap) {
        window.inpostMap.setView([uLat, uLng], 14, { animate: true });

        if (window.userLocationMarker) {
          window.inpostMap.removeLayer(window.userLocationMarker);
        }
        const userIcon = L.divIcon({
          className: 'user-loc-icon',
          html: '<div style="width: 16px; height: 16px; background: #0088ff; border: 3px solid #fff; border-radius: 50%; box-shadow: 0 0 12px #0088ff;"></div>',
          iconSize: [16, 16],
          iconAnchor: [8, 8]
        });
        window.userLocationMarker = L.marker([uLat, uLng], { icon: userIcon }).addTo(window.inpostMap);
      }

      renderLockerResults(closest, uLat, uLng);
    },
    err => {
      console.warn('Błąd geolokalizacji:', err);
      if (statusEl) statusEl.textContent = 'Nie udało się pobrać lokalizacji. Wpisz miasto lub kod w wyszukiwarce.';
    },
    { timeout: 10000 }
  );
};

// Selection handler called from popup or card
window.selectInpostPoint = function(code, fallbackAddr) {
  if (!code) return;
  let point = null;
  if (window.INPOST_POINTS && window.INPOST_POINTS.length) {
    point = window.INPOST_POINTS.find(p => p.n === code);
  }
  if (point) {
    const addr = (point.e ? `ul. ${point.e} ${point.b}` : point.b) + (point.c ? `, ${point.c}` : '');
    window.inpostPointSelected({
      name: point.n,
      address: { line1: addr, line2: (point.o ? point.o + ' ' : '') + (point.c || '') }
    });
  } else {
    window.inpostPointSelected({
      name: code,
      address: { line1: fallbackAddr || 'Wybrany Paczkomat' }
    });
  }
};

// Open and Close Modal
window.openInpostModal = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const modal = document.getElementById('inpost-modal-overlay');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    window.initInpostPicker();
  }
};

window.closeInpostModal = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const modal = document.getElementById('inpost-modal-overlay');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
};

window.inpostPointSelected = function(point) {
  if (!point || !point.name) return;
  console.log('Wybrany Paczkomat InPost:', point);

  try {
    localStorage.setItem('hypespot_inpost_point', JSON.stringify(point));
  } catch (err) {}

  window.updateInpostUI(point);
  window.closeInpostModal();

  // Send attributes and note to Shopify Cart API
  const addr = (point.address && point.address.line1) ? (point.address.line1 + (point.address.line2 ? ', ' + point.address.line2 : '')) : '';
  const fullStr = point.name + ' - ' + addr;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        'Paczkomat InPost': fullStr,
        'Kod Paczkomatu': point.name,
        'Adres Paczkomatu': addr
      },
      note: 'Wybrany Paczkomat InPost: ' + fullStr
    })
  }).catch(err => {
    console.warn('Błąd zapisu Paczkomatu w koszyku:', err);
  });
};

window.updateInpostUI = function(point) {
  if (!point || !point.name) return;
  const addr = (point.address && point.address.line1) ? (point.address.line1 + (point.address.line2 ? ', ' + point.address.line2 : '')) : '';

  // Drawer
  const dUnsel = document.getElementById('drawer-inpost-unselected');
  const dSel = document.getElementById('drawer-inpost-selected');
  const dName = document.getElementById('drawer-inpost-point-name');
  const dAddr = document.getElementById('drawer-inpost-point-addr');

  if (dUnsel && dSel && dName && dAddr) {
    dUnsel.style.display = 'none';
    dSel.style.display = 'flex';
    dName.textContent = point.name;
    dAddr.textContent = addr;
  }

  // Page
  const pUnsel = document.getElementById('page-inpost-unselected');
  const pSel = document.getElementById('page-inpost-selected');
  const pName = document.getElementById('page-inpost-point-name');
  const pAddr = document.getElementById('page-inpost-point-addr');

  if (pUnsel && pSel && pName && pAddr) {
    pUnsel.style.display = 'none';
    pSel.style.display = 'flex';
    pName.textContent = point.name;
    pAddr.textContent = addr;
  }
};

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    if (window.closeSearchOverlay) window.closeSearchOverlay();
    if (window.closeCartDrawer) window.closeCartDrawer();
    if (window.closeAuthDrawer) window.closeAuthDrawer();
    if (window.closeMobileMenu) window.closeMobileMenu();
    if (window.closeInpostModal) window.closeInpostModal();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize Lucide Icons
  if (window.lucide) {
    lucide.createIcons();
  }

  // Restore saved InPost Paczkomat point
  try {
    const savedPointStr = localStorage.getItem('hypespot_inpost_point');
    if (savedPointStr) {
      const savedPoint = JSON.parse(savedPointStr);
      window.updateInpostUI(savedPoint);
    }
  } catch (err) {}

  // 2. Mobile Navigation Drawer Toggle
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileDrawerClose = document.getElementById('mobile-drawer-close');
  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', window.openMobileMenu);
  if (mobileDrawerClose) mobileDrawerClose.addEventListener('click', window.closeMobileMenu);

  // 3. Search Bar Handlers (Inline Header Search & Fallback Overlay)
  const headerSearchInput = document.getElementById('header-search-input');
  const headerSearchForm = document.getElementById('header-search-form');
  const searchClearBtn = document.getElementById('search-clear-btn');
  const predictiveDropdown = document.getElementById('predictive-search-dropdown');
  const predictiveResults = document.getElementById('predictive-search-results');

  const searchTriggerBtn = document.getElementById('search-trigger-btn');
  const searchCloseBtn = document.getElementById('search-close-btn');
  const searchOverlayInput = document.getElementById('store-search-input');

  if (searchTriggerBtn) searchTriggerBtn.addEventListener('click', window.toggleSearchOverlay);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', window.closeSearchOverlay);

  let predictiveTimer = null;

  // Header Search Input Logic
  if (headerSearchInput) {
    if (headerSearchInput.value.trim().length > 0 && searchClearBtn) {
      searchClearBtn.style.display = 'inline-flex';
    }

    headerSearchInput.addEventListener('input', (e) => {
      const rawQuery = e.target.value;
      const query = rawQuery.trim();

      if (searchClearBtn) {
        searchClearBtn.style.display = query.length > 0 ? 'inline-flex' : 'none';
      }

      // Live filter cards on current page (e.g. index catalog)
      if (typeof window.filterProducts === 'function') {
        window.filterProducts(query.toLowerCase());
      }

      // Predictive search API query
      clearTimeout(predictiveTimer);
      if (query.length < 2) {
        if (predictiveDropdown) predictiveDropdown.style.display = 'none';
        return;
      }

      predictiveTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`)
          .then(res => {
            if (!res.ok) throw new Error('Network error');
            return res.json();
          })
          .then(data => {
            const products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
            if (!predictiveDropdown || !predictiveResults) return;

            if (products.length === 0) {
              predictiveResults.innerHTML = `
                <div class="predictive-no-results" style="padding: 1rem; text-align: center; color: var(--text-muted); font-size: 0.85rem;">
                  Brak bezpośrednich wyników dla "<strong>${query.replace(/</g, '&lt;')}</strong>"
                </div>
              `;
            } else {
              predictiveResults.innerHTML = `
                <div class="predictive-search-header">PRODUKTY (${products.length})</div>
                ${products.map(prod => `
                  <a href="${prod.url}" class="predictive-search-item">
                    <div class="predictive-item-thumb">
                      ${prod.image ? `<img src="${prod.image}" alt="${prod.title}">` : '<div class="predictive-placeholder" style="display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.05);height:100%;">📦</div>'}
                    </div>
                    <div class="predictive-item-info">
                      <span class="predictive-item-title">${prod.title}</span>
                      <span class="predictive-item-price">${prod.price} PLN</span>
                    </div>
                  </a>
                `).join('')}
                <a href="/search?q=${encodeURIComponent(query)}" class="predictive-view-all">
                  Zobacz wszystkie wyniki &rarr;
                </a>
              `;
            }
            predictiveDropdown.style.display = 'block';
          })
          .catch(err => {
            console.warn('Predictive search error:', err);
          });
      }, 250);
    });

    // Close predictive search when clicking outside
    document.addEventListener('click', (e) => {
      const container = document.getElementById('header-search-container');
      if (container && !container.contains(e.target)) {
        if (predictiveDropdown) predictiveDropdown.style.display = 'none';
      }
    });

    // Enter key / Form Submit logic
    if (headerSearchForm) {
      headerSearchForm.addEventListener('submit', (e) => {
        const query = headerSearchInput.value.trim();
        const catalogSec = document.getElementById('katalog');
        if (catalogSec && (window.location.pathname === '/' || window.location.pathname === '')) {
          e.preventDefault();
          if (predictiveDropdown) predictiveDropdown.style.display = 'none';
          if (typeof window.filterProducts === 'function') {
            window.filterProducts(query.toLowerCase());
          }
          catalogSec.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // Check URL for search parameter on page load
    const urlParams = new URLSearchParams(window.location.search);
    const initialQuery = urlParams.get('q') || urlParams.get('search');
    if (initialQuery) {
      headerSearchInput.value = initialQuery;
      if (searchClearBtn) searchClearBtn.style.display = 'inline-flex';
      if (typeof window.filterProducts === 'function') {
        window.filterProducts(initialQuery.toLowerCase());
      }
      const catalogSec = document.getElementById('katalog');
      if (catalogSec && (window.location.pathname === '/' || window.location.pathname === '')) {
        setTimeout(() => catalogSec.scrollIntoView({ behavior: 'smooth' }), 300);
      }
    }
  }

  // Fallback Overlay Search Input Logic
  if (searchOverlayInput) {
    searchOverlayInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();
      if (typeof window.filterProducts === 'function') {
        window.filterProducts(query);
      }
    });

    searchOverlayInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = searchOverlayInput.value.trim();
        const catalogSec = document.getElementById('katalog');
        if (catalogSec) {
          if (typeof window.filterProducts === 'function') {
            window.filterProducts(query.toLowerCase());
          }
          catalogSec.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.location.href = '/search?q=' + encodeURIComponent(query);
        }
      }
    });
  }

  // 4. Cart Drawer Toggle
  const cartToggleBtn = document.getElementById('cart-toggle-btn');
  const cartDrawerClose = document.getElementById('cart-drawer-close');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');

  if (cartToggleBtn) cartToggleBtn.addEventListener('click', window.openCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', window.closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', window.closeCartDrawer);

  // 4b. Customer Account / Auth Drawer Toggle
  const accountToggleBtn = document.getElementById('account-toggle-btn');
  const authDrawerClose = document.getElementById('auth-drawer-close');
  const authDrawerOverlay = document.getElementById('auth-drawer-overlay');

  if (accountToggleBtn) accountToggleBtn.addEventListener('click', window.openAuthDrawer);
  if (authDrawerClose) authDrawerClose.addEventListener('click', window.closeAuthDrawer);
  if (authDrawerOverlay) authDrawerOverlay.addEventListener('click', window.closeAuthDrawer);

  // Auth Drawer Tab Switcher (Login vs Register)
  window.switchDrawerAuth = function(tab) {
    const loginView = document.getElementById('drawer-login-view');
    const registerView = document.getElementById('drawer-register-view');
    const loginBtn = document.getElementById('tab-login-btn');
    const registerBtn = document.getElementById('tab-register-btn');

    if (tab === 'register') {
      if (loginView) loginView.style.display = 'none';
      if (registerView) registerView.style.display = 'block';
      if (loginBtn) loginBtn.classList.remove('active');
      if (registerBtn) registerBtn.classList.add('active');
    } else {
      if (loginView) loginView.style.display = 'block';
      if (registerView) registerView.style.display = 'none';
      if (loginBtn) loginBtn.classList.add('active');
      if (registerBtn) registerBtn.classList.remove('active');
    }
  };

  // Google Login Handler
  window.loginWithGoogle = function() {
    window.location.href = 'https://shopify.com/106365682001/account';
  };

  // 5. Category Filters Filtering
  const filterPills = document.querySelectorAll('.filter-pill');
  const navCategoryLinks = document.querySelectorAll('[data-category]');

  function applyCategoryFilter(cat) {
    const productCards = document.querySelectorAll('.product-card');

    // Update active pill state
    filterPills.forEach(pill => {
      if (pill.dataset.filter === cat) {
        pill.classList.add('active');
      } else {
        pill.classList.remove('active');
      }
    });

    productCards.forEach(card => {
      const cardCat = card.dataset.category || '';
      const cardTitle = card.dataset.title || '';

      if (cat === 'all') {
        card.style.display = 'flex';
      } else if (cat === 'okazje') {
        // Show cards with discount
        card.style.display = 'flex';
      } else if (cat === 'buty') {
        if (cardCat.includes('buty') || cardCat.includes('sneakers') || cardCat.includes('shoes') || cardTitle.includes('dunk') || cardTitle.includes('campus') || cardTitle.includes('jordan')) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      } else if (cat === 'bluzy') {
        if (cardCat.includes('bluzy') || cardCat.includes('hoodie') || cardCat.includes('kurtka') || cardTitle.includes('hoodie') || cardTitle.includes('kurtka') || cardTitle.includes('nuptse')) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      } else if (cat === 'tshirty') {
        if (cardCat.includes('tshirt') || cardCat.includes('koszulk') || cardTitle.includes('t-shirt') || cardTitle.includes('tee')) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      } else if (cat === 'spodnie') {
        if (cardCat.includes('spodni') || cardCat.includes('dres') || cardTitle.includes('bojówki') || cardTitle.includes('cargo') || cardTitle.includes('pants')) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      } else if (cat === 'elegancja') {
        if (cardCat.includes('sukienk') || cardCat.includes('marynark') || cardCat.includes('elegan') || cardCat.includes('dress') || cardCat.includes('blazer') || cardTitle.includes('sukienk') || cardTitle.includes('marynark') || cardTitle.includes('żakiet')) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      } else if (cat === 'akcesoria') {
        if (cardCat.includes('akcesoria') || cardCat.includes('biżuteri') || cardCat.includes('okular') || cardCat.includes('zegark') || cardCat.includes('accessories') || cardTitle.includes('okular') || cardTitle.includes('naszyjnik') || cardTitle.includes('bransoletka') || cardTitle.includes('pasek') || cardTitle.includes('czapka') || cardTitle.includes('biżuteria')) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      } else {
        if (cardCat.includes(cat) || cardTitle.includes(cat)) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      }
    });
  }

  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      applyCategoryFilter(pill.dataset.filter);
    });
  });

  navCategoryLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const cat = link.dataset.category;
      if (cat) {
        if (mobileDrawer) mobileDrawer.classList.remove('open');
        applyCategoryFilter(cat);
        const catalogSec = document.getElementById('katalog');
        if (catalogSec) {
          catalogSec.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  window.filterProducts = function(query) {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(card => {
      const title = card.dataset.title || '';
      const brand = card.dataset.brand || '';
      const cat = card.dataset.category || '';

      if (!query || title.includes(query) || brand.includes(query) || cat.includes(query)) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  // 6. AJAX Add to Cart (Product Page)
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = document.getElementById('add-cart-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Dodawanie...';
      }

      const formData = new FormData(addToCartForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        // Refresh cart drawer
        refreshCartDrawer();
        window.openCartDrawer();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<i data-lucide="check"></i> Dodano do koszyka!';
          if (window.lucide) lucide.createIcons();
          setTimeout(() => {
            submitBtn.innerHTML = '<i data-lucide="shopping-bag"></i> Dodaj do koszyka';
            if (window.lucide) lucide.createIcons();
          }, 2000);
        }
      })
      .catch(err => {
        console.error('Błąd dodawania do koszyka:', err);
        // Fallback to standard post
        addToCartForm.submit();
      });
    });
  }

  // Helper to reload drawer cart contents via Shopify Cart API
  window.refreshCartDrawer = function() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Update counters
        const cartCounters = document.querySelectorAll('#cart-counter, #drawer-cart-count');
        cartCounters.forEach(el => el.textContent = cart.item_count);

        const subtotalEl = document.getElementById('drawer-subtotal');
        if (subtotalEl) {
          subtotalEl.textContent = (cart.total_price / 100).toFixed(2) + ' PLN';
        }

        const itemsContainer = document.getElementById('cart-drawer-items');
        const footer = document.getElementById('cart-drawer-footer');

        if (cart.item_count === 0) {
          if (itemsContainer) {
            itemsContainer.innerHTML = `
              <div class="cart-empty-state">
                <i data-lucide="shopping-bag" class="cart-empty-icon"></i>
                <p>Twój koszyk jest pusty</p>
                <a href="/#katalog" class="btn btn-outline btn-sm" onclick="closeCartDrawer()">Przeglądaj okazje</a>
              </div>
            `;
          }
          if (footer) footer.style.display = 'none';
        } else {
          if (footer) footer.style.display = 'block';
          if (itemsContainer) {
            itemsContainer.innerHTML = cart.items.map((item, index) => `
              <div class="drawer-item" data-line="${index + 1}">
                <div class="drawer-item-img">
                  <img src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}">
                </div>
                <div class="drawer-item-info">
                  <h4 class="drawer-item-title">${item.product_title}</h4>
                  ${item.variant_title ? `<span class="drawer-item-variant">Rozmiar: ${item.variant_title}</span>` : ''}
                  <div class="drawer-item-price-row">
                    <span class="drawer-item-price">${(item.price / 100).toFixed(2)} PLN</span>
                    <div class="drawer-qty-selector">
                      <button class="qty-btn" onclick="updateDrawerQty(${index + 1}, ${item.quantity - 1})">-</button>
                      <span class="qty-number">${item.quantity}</span>
                      <button class="qty-btn" onclick="updateDrawerQty(${index + 1}, ${item.quantity + 1})">+</button>
                    </div>
                  </div>
                </div>
                <button class="item-remove-btn" onclick="updateDrawerQty(${index + 1}, 0)" aria-label="Usuń"><i data-lucide="trash-2"></i></button>
              </div>
            `).join('');
          }
        }
        try {
          const s = localStorage.getItem('hypespot_inpost_point');
          if (s) window.updateInpostUI(JSON.parse(s));
        } catch (e) {}
        if (window.lucide) lucide.createIcons();
      });
  }

  // Update Drawer Line Quantity
  window.updateDrawerQty = function(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(res => res.json())
    .then(cart => {
      refreshCartDrawer();
    });
  };

  // Update Cart Full Page Quantity
  window.updateCartPageQty = function(line, quantity) {
    if (quantity <= 0) {
      window.location.href = `/cart/change?line=${line}&quantity=0`;
    } else {
      window.location.href = `/cart/change?line=${line}&quantity=${quantity}`;
    }
  };
});

// Product Page Global Helpers
window.changeMainImg = function(src, btn) {
  const mainImg = document.getElementById('main-product-img');
  if (mainImg) mainImg.src = src;

  document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
};

window.selectProductVariant = function(btn) {
  if (btn.classList.contains('disabled')) return;

  document.querySelectorAll('.size-pill-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');

  const variantId = btn.dataset.variantId;
  const price = btn.dataset.price;
  const compare = btn.dataset.compare;

  const variantInput = document.getElementById('selected-variant-id');
  if (variantInput) variantInput.value = variantId;

  const dynamicPrice = document.getElementById('dynamic-price');
  if (dynamicPrice && price) dynamicPrice.textContent = price;

  const dynamicCompare = document.getElementById('dynamic-compare');
  if (dynamicCompare && compare) dynamicCompare.textContent = compare;
};

window.toggleAccordion = function(id) {
  const item = document.getElementById(`${id}-accordion`);
  if (item) {
    item.classList.toggle('active');
  }
};

